// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.authenticated-layout {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}

.authenticated-main {
    margin-top: 80px;
    flex: 1 1;
    padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/layouts/AuthenticatedLayout.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,SAAO;IACP,aAAa;AACjB","sourcesContent":[".authenticated-layout {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.authenticated-main {\n    margin-top: 80px;\n    flex: 1;\n    padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
